<div class="d-lg-block d-none">
  <div class="banner justify-content-center" role="banner">
    <h1 class="text-white">{{ 'games.page.title' | translate }}</h1>
  </div>
</div>

<div class="d-lg-none">
  <fgb-barcode></fgb-barcode>
</div>
<div class="container mt-3">
  <div class="game-container-sections">
    <div>
      <img alt="trivia" src="assets/images/games/Trivia.jpg" />
      <div class="card">
        <div class="">
          <h5>{{ 'games.page.trivia' | translate }}</h5>
          <div class="font-size-14">{{ 'games.page.trivia.description' | translate }}</div>
        </div>
        <div [routerLink]="'/games/trivia'">
          <div class="btn">{{ 'games.page.trivia.play' | translate }}</div>
        </div>
      </div>
    </div>
    <div>
      <img alt="predictor" src="assets/images/games/Predictor.jpg" />
      <div class="card">
        <div class="">
          <h5>{{ 'games.page.predictor' | translate }}</h5>
          <div class="font-size-14">{{ 'games.page.predictor.description' | translate }}</div>
        </div>
        <div [routerLink]="'/games/predictor'">
          <div class="btn">{{ 'games.page.predictor.play' | translate }}</div>
        </div>
      </div>
    </div>
    <div>
      <img alt="polls" src="assets/images/games/Polls.jpg" />
      <div class="card">
        <div class="">
          <h5>{{ 'games.page.polls' | translate }}</h5>
          <div class="font-size-14">{{ 'games.page.polls.description' | translate }}</div>
        </div>
        <div [routerLink]="'/games/polls'">
          <div class="btn">{{ 'games.page.polls.play' | translate }}</div>
        </div>
      </div>
    </div>
  </div>
</div>
